// extracted by mini-css-extract-plugin
module.exports = {"tools":"OrderStatusPage_tools__30W2z","mobileTools":"OrderStatusPage_mobileTools__mY1q0","page":"OrderStatusPage_page__1uE5e","right":"OrderStatusPage_right__2bwHC"};